export default __webpack_public_path__ + "static/footer_pc-b0af1edbad321bb629d14cffd7696712.png";